import Accordion from '@/common/components/Accordion'
import { formatCurrency } from '@/common/utils/formatters'
import { ContractProductCategoryItem } from '@/features/privateCompanies/components/showContract/CreditLimits/ContractProductCategoryItem'
import { UpdateCreditLimitsModal } from '@/features/privateCompanies/components/updateContract/UpdateCreditLimitsModal'
import { consumptionControlledBy } from '@/features/privateCompanies/constants/politics/creditLimits/consumptionControlledBy.constant'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import {
  strategy as priceRuleStrategy,
  privateFuelStrategy,
} from '@/features/publicCompanyLeadsFunnel/constants/priceRuleOptions.constant'
import { CircleChevronDownIcon, DollarSignIcon, SquareCheckIcon } from 'lucide-react'

interface CreditLimitsProps {
  contract?: CompanyContractType
  companyKind?: string
}

export const CreditLimits = ({ contract, companyKind }: CreditLimitsProps) => {
  return (
    <Accordion
      defaultOpen
      name="credit_limits"
      head={
        <div className="flex items-center gap-x-2">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateCreditLimitsModal contract={contract} companyKind={companyKind} />
          </div>

          <p className="text-white-800">Limites de Crédito</p>
        </div>
      }
      triggerClassName="py-2"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-y-4">
          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">Valor global do contrato:</p>

            <div className="flex items-center gap-x-1">
              <DollarSignIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_granted_credit" className="text-xs text-white-400">
                {companyKind === 'public_company'
                  ? contract?.global_value
                    ? formatCurrency(parseFloat(contract.global_value))
                    : '--'
                  : contract?.granted_credit
                  ? formatCurrency(parseFloat(contract.granted_credit))
                  : '--'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">Informar valores de cota:</p>

            <div className="flex items-center gap-x-1">
              <SquareCheckIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_require_product_credit_quota" className="text-xs text-white-400">
                {contract?.require_product_credit_quota ? 'Sim' : 'Não'}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">Consumo controlado por:</p>

            <div className="flex items-center gap-x-1">
              <SquareCheckIcon strokeWidth={1} className="size-5 text-white-400" />

              <p data-testid="contract_require_product_credit_quota" className="text-xs text-white-400">
                {contract?.consumption_controlled_by ? consumptionControlledBy[contract?.consumption_controlled_by] : '--'}
              </p>
            </div>
          </div>

          {!!contract?.contract_product_categories?.length && (
            <>
              <p className="text-[11px] leading-3 text-white-800">Serviços e Produtos:</p>

              {contract?.contract_product_categories?.map((contractProductCategory, index) => (
                <ContractProductCategoryItem
                  key={contractProductCategory.id}
                  contractProductCategory={contractProductCategory}
                  contractProductCategoryIndex={index}
                  contract={contract}
                />
              ))}
            </>
          )}

          <div className="flex items-center gap-x-2">
            <p className="text-[11px] leading-3 text-white-800">Regra de Preço (Padrão):</p>

            <div className="flex items-center gap-x-1">
              <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

              <p className="text-xs text-white-400">
                {contract?.default_fuel_price_rule
                  ? privateFuelStrategy[contract.default_fuel_price_rule as keyof typeof priceRuleStrategy]
                  : '--'}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}
